import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'

const CanonicalUrl = (props) => {
	if (props.pathname && props.rootUrl) {
		const value = `${props.rootUrl}${props.pathname}`

		return (
			<Helmet>
				<link rel="canonical" href={value} />
			</Helmet>
		)
	}

	return null
}

CanonicalUrl.propTypes = {
	pathname: PropTypes.string,
	rootUrl: PropTypes.string,
}

export default CanonicalUrl


// WEBPACK FOOTER //
// ./src/common/components/meta/canonical-url.js